import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageInsitutionManagementService } from '../../ph-bhp-feature-package-insitution-management.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslationKeys } from 'ph-bhp-localization';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css']
})
export class UserDetailsComponent implements OnInit {
  translationKeys: typeof TranslationKeys = TranslationKeys;
  gridData: any;
  subscription: Subscription;
  institutionId = 0;
  institutionData;
  deleteDataItem;
  modalRef: BsModalRef;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;

  emitData: any = {
    key: '',
    val: ''
  };

  pageInfo = {
    ofLabel: "GENERAL.OF", //'of',
    items: "LAYOUT_MODULE.USERS",// 'users',
    itemsPerPageLabel: "USER_MANAGEMENT.USERS_PER_PAGE"//'users per page'
  };

  actionItems: any = [
    { name: 'LAYOUT_MODULE.VIEW', imgSrc: 'assets/ph-bhp-layout/svg/icon-view.svg', onClick: (dataItem) => { this.view(dataItem); } },
    // tslint:disable-next-line: max-line-length
    { name: 'LAYOUT_MODULE.DELETE', imgSrc: 'assets/ph-bhp-layout/svg/icon-delete.svg', onClick: (dataItem) => { this.openDeleteModal(this.delmodal, dataItem) } },
    // { name: 'Edit', imgSrc: 'assets/ph-bhp-layout/svg/icon-edit.svg', onClick: (dataItem) => { this.edit(dataItem) } }
  ];

  horizontalAction: boolean = true;

  public fields: any[];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    public translate: TranslateService,
    public config: AppConfig,
    private service: PHBHPFeaturePackageInsitutionManagementService,
    public layoutService: PHBHPLayoutPackageService
  ) {
    this.fields = [
      { 'field': 'name', 'width': 150,'title': this.layoutService.translateText('USER_MANAGEMENT.NAME')  }, // Name
      { 'field': 'institutionName',  'width': 200 ,'title': this.layoutService.translateText('USER_MANAGEMENT.INSTITUTIONS')  }, //'Institutions',} ,
      { 'field': 'city',  'width': 100 , 'title': this.layoutService.translateText('USER_MANAGEMENT.LOCATION')  }, //'Location',},
      { 'field': 'email',  'width': 300 , 'title': this.layoutService.translateText('USER_MANAGEMENT.E_MAIL')  }, //'E-mail',},
      { 'field': 'roleName', 'width': 200 , 'title': this.layoutService.translateText(this.translationKeys.ProfileDetails.Role)  }, //'Role', },
    ];
  }

  ngOnInit() {
    this.fields = [
      { 'field': 'name', 'width': 150, 'title': this.layoutService.translateText('USER_MANAGEMENT.NAME') }, // Name
      { 'field': 'institutionName', 'width': 200, 'title': this.layoutService.translateText('USER_MANAGEMENT.INSTITUTIONS') }, //'Institutions',} ,
      { 'field': 'city', 'width': 100, 'title': this.layoutService.translateText('USER_MANAGEMENT.LOCATION') }, //'Location',},
      { 'field': 'email', 'width': 300, 'title': this.layoutService.translateText('USER_MANAGEMENT.E_MAIL') }, //'E-mail',},
      { 'field': 'roleName', 'width': 200, 'title': this.layoutService.translateText(this.translationKeys.ProfileDetails.Role) }, //'Role', },
    ];

    this.institutionId = this.activatedRoute.snapshot.parent.params.id;
    this.getInstitutionDetails();
    this.subscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      this.getInstitutionDetails();
    });
  }

  getInstitutionDetails() {
    this.layoutService.showLoader = true;
    this.service.GetInstitutionDetails(this.institutionId).subscribe((res: any) => {
      this.institutionData = res;
      if (!this.institutionData.userDetails) {
        this.layoutService.showLoader = false;
        return;
      }

      let that = this;
      this.gridData = this.institutionData.userDetails.map(item => this.manageGrid(item, that));
      if (this.gridData) {
        this.changeLangCommentPage();
      }
      this.layoutService.showLoader = false;
    }, err => {
      this.layoutService.showLoader = false;
    });
  }

  changeLangCommentPage() {
    this.fields = [
      { 'field': 'name', 'width': 150,'title': this.layoutService.translateText('USER_MANAGEMENT.NAME')  }, // Name
      { 'field': 'institutionName',  'width': 200 ,'title': this.layoutService.translateText('USER_MANAGEMENT.INSTITUTIONS')  }, //'Institutions',} ,
      { 'field': 'city',  'width': 100 , 'title': this.layoutService.translateText('USER_MANAGEMENT.LOCATION')  }, //'Location',},
      { 'field': 'email',  'width': 300 , 'title': this.layoutService.translateText('USER_MANAGEMENT.E_MAIL')  }, //'E-mail',},
      { 'field': 'roleName', 'width': 200 , 'title': this.layoutService.translateText(this.translationKeys.ProfileDetails.Role)  }, //'Role', },
    ];
    this.gridData.forEach((value, index) => {
        this.gridData[index].roleName = this.layoutService.translateText(value.roleName);
        this.gridData[index].city = this.layoutService.translateText(value.city);
    });
  }

  view(dataItem) {
    this.onChildData('user/view/' + dataItem.user.userId);
  }

  edit(dataItem) {
    // this.emitData = {};
    // this.emitData.key = 'user/edit/' + dataItem.user.userId;
    this.onChildData('user/edit/' + dataItem.user.userId);
  }

  onChildData(emitter) {
    this.router.navigate([emitter]);
  }

  delete() {
    this.service.deleteUser(this.deleteDataItem.user.userId).subscribe(((res: any) => {
      const data: any[] = JSON.parse(JSON.stringify(this.gridData));
      this.gridData = [];
      const index = data.findIndex(user => user.user.userId === this.deleteDataItem.user.userId);
      data.splice(index, 1);
      let that = this;
      this.gridData = data.map(item => this.manageGrid(item, that));;;
    }));
  }

  openDeleteModal(deletemodal: TemplateRef<any>, dataItem) {
    this.deleteDataItem = dataItem;
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    );
  }

  manageGrid(item, that){

    item.name = item.user.name;
    item.roleName = item.role.roleName;
    item.institutionName = item.institutions[0].institutionName;
    item.city = item.institutions[0].city;
    item.email = item.user.email;

    return item;
  }

}
